const Header = () => {
  return (
    <>
      <header>
        <h1 className="Reviewsable">
          REVIEWSABLE
          <div className="Pen">🖋</div>
          <div className="Dice">🎲</div>
        </h1>
      </header>
    </>
  );
};

export default Header;
